export const NotificationTypeGridMessages = {
  notificationTypeRow: {
    reminderOffsetLabel: {
      id: 'notificationTypeRow.Offset.Reminder',
      defaultMessage: 'When to receive notifications',
    },
    emailLabel: {
      id: 'notificationTypeRow.Label.Email',
      defaultMessage: 'by email',
    },
    emailAriaLabel: {
      id: 'notificationTypeRow.Label.EmailAria',
      defaultMessage: 'Receive notifications by email',
    },
    smsLabel: {
      id: 'notificationTypeRow.Label.Sms',
      defaultMessage: 'by text',
    },
    smsAriaLabel: {
      id: 'notificationTypeRow.Label.SmsAria',
      defaultMessage: 'Receive notifications by text message',
    },
  },
};
